import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    calculate(_event) {
        const paymentAmount = document.getElementById('payment_amount').value;
        this.stimulate('ProcessingFeesReflex#calculate', parseFloat(paymentAmount));
    }
}